import { ContextualHint } from '@src/components/common/ContextualHint';

import type { FC, ReactNode } from 'react';

/**
 * PLAT-12025 — re-dubbing a passage is reached only by highlighting words in
 * the dubbed transcript and choosing Re-dub AI Voice from the menu that
 * appears. Nothing on the screen says so ("the discoverability of knowing to
 * highlight and do this is bad", AJ, 2026-10-08). So the first time a person
 * opens Dubbing Review where that is possible, a coach mark under the
 * transcript's header says it. Per person, not per story: closed once, or a
 * re-dub asked for once, it is gone for this browser — a **new-feature
 * notice**, the sibling of PLAT-11980's move notice. See "Contextual Hints"
 * in docs/design-system.md.
 */
export const SECTION_REDUB_HINT_KEY = 'section-redub';

export const SECTION_REDUB_HINT_TEXT =
  'New: highlight any words below to re-dub just that passage, with a direction of your own.';

type Props = {
  /** The host's gate — true only where a highlighted passage can be re-dubbed. */
  show: boolean;
  /** The header the hint hangs from. */
  children: ReactNode;
};

export const SectionRedubHint: FC<Props> = ({ show, children }) => (
  <ContextualHint
    hintKey={SECTION_REDUB_HINT_KEY}
    show={show}
    placement="bottom-start"
    text={SECTION_REDUB_HINT_TEXT}
    testId="section-redub-hint"
    // The header it wraps shortens with "…" in the narrow Dubbing column.
    shrink
  >
    {children}
  </ContextualHint>
);

export default SectionRedubHint;
